import type { Messages } from "./en";

export const it: Messages = {
  "nav.home": "Home di LEARNABLE",
  "nav.main": "Principale",
  "nav.courses": "Corsi",
  "nav.review": "Ripasso",
  "nav.progress": "Progressi",
  "nav.guide": "Guida",
  "nav.marketplace": "Marketplace",
  "nav.streak": "Serie di giorni: {n}",
  "nav.xp": "Esperienza totale: {n} XP",

  "account.menu": "Account",
  "account.settings": "Impostazioni",
  "account.guide": "Come funziona LEARNABLE",
  "account.signOut": "Esci",

  "common.save": "Salva",
  "common.saved": "Salvato.",
  "common.saving": "Salvataggio…",
  "common.cancel": "Annulla",
  "common.close": "Chiudi",
  "common.pleaseWait": "Attendi…",

  "signin.title": "Accedi a LEARNABLE",
  "signin.registerTitle": "Crea il tuo account",
  "signin.email": "Email",
  "signin.password": "Password",
  "signin.passwordRule": "Almeno 12 caratteri.",
  "signin.submit": "Accedi",
  "signin.register": "Crea account",
  "signin.forgot": "Hai dimenticato la password?",
  "signin.toRegister": "Crea un account",
  "signin.toSignIn": "Ho già un account",
  "signin.language": "Lingua",

  "password.current": "Password attuale",
  "password.new": "Nuova password (almeno 12 caratteri)",
  "password.change": "Cambia password",
  "password.changed": "Password cambiata. Gli altri dispositivi sono stati disconnessi.",

  "settings.title": "Impostazioni",
  "settings.intro": "Il tuo profilo e le tue preferenze. Sono salvati nel tuo account e valgono su tutti i dispositivi.",
  "settings.profile": "Profilo",
  "settings.displayName": "Nome visualizzato",
  "signin.emailOrUsername": "Email o nome utente",
  "signin.username": "Nome utente (facoltativo)",
  "signin.usernameHint": "3–30 lettere, cifre, punti, trattini o underscore. Puoi accedere con questo al posto dell'email.",
  "settings.username": "Nome utente",
  "settings.usernameHint": "Facoltativo. Ti permette di accedere con questo nome al posto dell'email. Gli altri non lo vedono. Lascialo vuoto per rimuoverlo.",
  "settings.displayNameHint": "Mostrato al posto dell'email. Lascialo vuoto per usare l'email.",
  "settings.email": "Email",
  "settings.emailHint": "L'indirizzo con cui accedi.",
  "settings.language": "Lingua",
  "settings.languageHint": "La lingua di menu e pagine. Il materiale dei corsi e il feedback dell'AI restano nella lingua del corso.",
  "settings.translationNote": "Traduzione in corso: alcune schermate sono ancora in inglese.",
  "settings.study": "Studio",
  "settings.timezone": "Fuso orario",
  "settings.timezoneHint": "La giornata di studio, la serie e l'obiettivo giornaliero seguono questo fuso orario.",
  "settings.dailyGoal": "Obiettivo giornaliero",
  "settings.dailyGoalHint": "Risposte al giorno.",
  "settings.security": "Sicurezza",
  "settings.signOutHint": "Uscendo, i dati del tuo account vengono rimossi da questo browser.",

  "guide.title": "Come funziona LEARNABLE",
  "guide.intro": "LEARNABLE trasforma il tuo materiale di studio in domande, valuta le tue risposte e programma ogni ripasso poco prima che tu possa dimenticare.",
  "guide.contents": "Indice",
  "guide.structure.title": "1. Com'è organizzato un corso",
  "guide.structure.body": "Un corso è diviso in capitoli, i capitoli in argomenti e gli argomenti in concetti. Ogni concetto contiene elementi di apprendimento: le nozioni da ricordare, ciascuna chiesta con una o più domande.",
  "guide.material.title": "2. Aggiungi il tuo materiale",
  "guide.material.body": "Apri un corso e carica file PDF, Word, PowerPoint, di testo o Markdown, oppure incolla del testo. Se hai già domande e risposte, caricale con righe che iniziano con \"Domanda:\" e \"Risposta:\" (o \"Question:\" e \"Answer:\"): ognuna diventa un concetto, senza usare l'AI.",
  "guide.curriculum.title": "3. Costruisci il programma",
  "guide.curriculum.body": "Chiedi all'AI di proporre capitoli, argomenti e concetti dal tuo materiale. Controlla la proposta, rinomina, sposta o elimina ciò che vuoi, poi accettala. Nulla cambia finché non accetti.",
  "guide.study.title": "4. Studia un concetto",
  "guide.study.body": "Apri un concetto e premi Attiva: le voci di apprendimento vengono preparate dal tuo materiale. Leggile, poi premi \"Ho studiato questo concetto\". Ogni domanda viene posta finché non hai risposto bene tre volte (non necessariamente di fila), con un riscontro dopo ogni risposta.",
  "guide.answer.title": "5. Rispondi e ricevi un feedback",
  "guide.answer.body": "Scrivi la risposta con parole tue, oppure premi \"Dì la tua risposta\" per dettarla. È disponibile un suggerimento, ma dimezza gli XP. L'AI valuta il significato, non le parole esatte, e mostra quattro punteggi e un elenco di ciò che era giusto, mancante o sbagliato. La risposta di riferimento e le sue fonti sono sempre a un clic.",
  "guide.disagree.title": "6. Se non sei d'accordo",
  "guide.disagree.body": "Premi \"Disagree with the grade?\". Puoi spiegare perché e chiedere all'AI un secondo parere (restano visibili entrambi), oppure valutare tu la risposta. Il tuo voto prevale sempre.",
  "guide.review.title": "7. Ripassa al momento giusto",
  "guide.review.body": "Ogni risposta sposta la sua domanda nel calendario: meglio la conosci, più tardi torna. La pagina Ripasso e la dashboard mostrano cosa è in scadenza e quanto tempo serve all'incirca.",
  "guide.progress.title": "8. Segui i tuoi progressi",
  "guide.progress.body": "La serie conta i giorni in cui hai studiato, gli XP premiano le risposte corrette e l'obiettivo giornaliero dà il ritmo. \"Cosa continui a sbagliare\" raccoglie gli errori trovati nelle risposte recenti, con un pulsante per esercitarti.",
  "guide.organise.title": "9. Tieni tutto in ordine",
  "guide.organise.body": "In \"Gestisci le domande\" puoi selezionare singole domande o interi capitoli, argomenti e concetti per eliminarli, sospenderli, riprenderli o spostarli, modificare una domanda e trascinare ⠿ per riordinare. Le sezioni lunghe si chiudono con la freccia accanto al titolo.",
  "guide.marketplace.title": "10. Condividi e trova corsi",
  "guide.marketplace.body": "Nel Marketplace trovi corsi creati da altri utenti, per categoria, livello, lingua e dimensione. Prima di aggiungerne uno vedi la sua pagina: cosa tratta, a chi è rivolto, cosa imparerai, i capitoli e quante domande contiene. \"Aggiungi ai miei corsi\" lo mette nella tua dashboard: l'autore tiene aggiornate le domande e tu non puoi modificarle, ma lo studio è tuo (il piano, le risposte, gli XP e la priorità che dai a ogni domanda). Il materiale dell'autore non si può scaricare. Per condividere un tuo corso, aprilo e scrivi la sua \"Pagina del marketplace\", salvala come bozza e poi pubblicala.",
  "guide.glossary.title": "Parole usate nell'app",
  "guide.term.concept": "Concetto",
  "guide.term.concept.def": "Un'idea del corso, come una definizione o una regola.",
  "guide.term.item": "Elemento di apprendimento",
  "guide.term.item.def": "Una nozione da ricordare dentro un concetto, con le sue domande e la risposta attesa.",
  "guide.term.active": "Active (attivo)",
  "guide.term.active.def": "Il concetto partecipa a studio e ripassi. Quelli sospesi o non studiati no.",
  "guide.term.grades": "Ancora · Difficile · Bene · Facile",
  "guide.term.grades.def": "Di nuovo, difficile, bene, facile: quanto bene conoscevi la risposta. Decide quando la domanda tornerà.",
  "guide.term.mastery": "Padronanza",
  "guide.term.mastery.def": "Una stima di quanto bene ricordi un concetto, calcolata dai ripassi.",
  "guide.term.xp": "XP e serie",
  "guide.term.xp.def": "Punti per le risposte corrette, e il numero di giorni di fila in cui hai studiato.",
  "guide.privacy.title": "I tuoi dati",
  "guide.privacy.body": "Corsi, risposte e progressi sono visibili solo a te. La dettatura è trascritta dal browser; viene conservato solo il testo.",
  "help.button": "Aiuto: {topic}",
  "help.more": "Scopri di più",
  "help.nextStep": "La cosa più utile da fare adesso. I ripassi in scadenza vengono sempre prima, poi il materiale nuovo.",
  "help.courses": "Una scheda per corso. Il pulsante verde ripassa ciò che è in scadenza; quello blu continua con qualcosa di nuovo.",
  "help.streak": "Giorni di fila con almeno una risposta. Rispondi a una domanda oggi per non interromperla.",
  "help.xp": "Punti esperienza, guadagnati con le risposte corrette. Usare un suggerimento li dimezza.",
  "help.goal": "Quante risposte vuoi dare ogni giorno. Puoi cambiarlo nelle Impostazioni.",
  "help.planner": "Quante domande scadono entro ciascun momento e quanto tempo richiedono all'incirca.",
  "help.coursePlanner": "Solo questo corso: quante delle sue domande scadono e quando, e circa quanto tempo richiedono. Il materiale nuovo richiede almeno tre risposte buone per domanda.",
  "help.activity": "Un quadrato per giorno: più è scuro, più hai risposto.",
  "help.concept": "Un concetto è un'idea del tuo corso. Inizia a studiarlo per preparare le domande, leggi i suoi elementi di apprendimento, poi esercitati.",
  "help.consolidate": "Premi il pulsante dopo aver letto le voci di apprendimento qui sotto. Ogni domanda viene posta finché non hai risposto bene tre volte, così resta.",
  "help.study": "Scrivi la risposta con parole tue o dettala. L'AI valuta il significato, non le parole esatte, e mostra cosa era giusto o mancante.",
  "help.questions": "Seleziona singole domande o un intero capitolo, argomento o concetto, poi eliminali, sospendili o spostali. Trascina ⠿ per cambiare l'ordine.",
  "help.marketplace": "Corsi creati da altri utenti. Aprine uno per vedere cosa tratta e quante domande contiene; aggiungilo per studiarlo con il tuo piano. L'autore lo tiene aggiornato.",
  "help.weakSpots": "Gli errori trovati nelle tue ultime risposte, raggruppati per concetto. Esercitati finché non spariscono da questo elenco.",
  "help.material": "Carica file PDF, Word, PowerPoint o di testo, oppure incolla del testo. LEARNABLE ne ricava il corso e le domande.",
  "start.title": "Come funziona LEARNABLE",
  "start.intro": "Quattro passaggi. Aprine uno per vederlo nella guida.",
  "start.hide": "Ho capito, nascondi",
  "start.reopen": "Mostra come funziona LEARNABLE",
  "start.material.title": "Aggiungi il materiale",
  "start.material.body": "Crea un corso e carica appunti, slide o libri, oppure incolla del testo.",
  "start.plan.title": "Approva il programma",
  "start.plan.body": "L'AI propone capitoli e concetti. Modifica ciò che vuoi, poi accetta.",
  "start.study.title": "Studia e rispondi",
  "start.study.body": "Leggi un concetto, poi rispondi alle sue domande con parole tue o a voce.",
  "start.review.title": "Ripassa al momento giusto",
  "start.review.body": "Le domande tornano poco prima che tu le dimentichi. Segui il pulsante verde.",
  "nav.community": "Community",
  "community.title": "Community",
  "community.intro": "Scopri chi guadagna più esperienza, segui altri studenti e incoraggiali.",
  "community.tab.leaderboard": "Classifica",
  "community.tab.friends": "Amici",
  "community.period": "Periodo",
  "community.scope": "Chi",
  "community.period.day": "Oggi",
  "community.period.week": "Questa settimana",
  "community.period.month": "Questo mese",
  "community.period.all": "Di sempre",
  "community.scope.everyone": "Tutti",
  "community.scope.friends": "Amici",
  "community.leader": "In testa",
  "community.xp": "{n} XP",
  "community.you": "Tu",
  "community.yourPlace": "Il tuo posto",
  "community.empty": "Nessuno ha ancora guadagnato XP in questo periodo.",
  "community.emptyFriends": "Segui altri studenti per confrontarti con loro qui.",
  "community.windowNote": "I giorni seguono l'ora UTC; le settimane iniziano di lunedì. Compaiono solo le persone che si sono unite alla community.",
  "community.joinTitle": "Unisciti alla community",
  "community.joinText": "Non sei ancora in classifica. Attiva la visibilità nella community per comparire, farti trovare e farti seguire. Gli altri vedono solo il tuo nome visualizzato e i tuoi XP, mai la tua email.",
  "community.joinButton": "Mostrami nella community",
  "community.needName": "Prima scegli un nome visualizzato nelle Impostazioni.",
  "community.follow": "Segui",
  "community.following": "Segui già",
  "community.friend": "Amici",
  "community.followsYou": "Ti segue",
  "community.since": "Impara qui dal {date}",
  "community.statXpTotal": "XP totali",
  "community.statXpWeek": "XP questa settimana",
  "community.statStreak": "Serie di giorni",
  "community.statFollowers": "Follower",
  "community.statFollowing": "Seguiti",
  "community.followingList": "Persone che segui",
  "community.followersList": "I tuoi follower",
  "community.searchLabel": "Cerca studenti per nome",
  "community.searchPlaceholder": "Cerca per nome visualizzato",
  "community.search": "Cerca",
  "community.noResults": "Nessuno trovato. Si possono trovare solo le persone che si sono unite alla community.",
  "community.noFollowing": "Non segui ancora nessuno.",
  "community.noFollowers": "Ancora nessun follower.",
  "community.streakDays": "Serie di {n} giorni",
  "community.xpToday": "{n} XP oggi",
  "community.notFound": "Questo profilo non è disponibile.",
  "community.seeLeaderboard": "Vedi la classifica della community",
  "course.leaderboardLink": "Classifica del corso",
  "course.leaderboardTitle": "Classifica del corso",
  "course.leaderboardIntro": "XP guadagnati in questo corso da chiunque lo abbia.",
  "course.leaderboardPrivate": "Questo è un corso privato, quindi in classifica ci sei solo tu. I corsi del Marketplace sono condivisi con tutti quelli che li hanno.",
  "course.leaderboardParticipants": "{n} studenti condividono questo corso.",
  "settings.community": "Community",
  "settings.communityToggle": "Mostrami nella community (classifiche, ricerca e follower)",
  "settings.communityHint": "Disattivato di default. Gli altri vedono solo il tuo nome visualizzato, i tuoi XP e la tua serie di giorni, mai la tua email, i tuoi corsi o le tue risposte. Serve un nome visualizzato per attivarlo.",
  "study.repeat.badge": "Quasi: ripetila",
  "study.repeat.title": "Rileggi la risposta di riferimento, poi ripetila",
  "study.repeat.body": "La tua risposta era solida sulla maggior parte dei punti. Leggi la risposta di riferimento qui sopra, poi riscrivila con parole tue. Se la ripeti bene conta come risposta corretta e il tuo piano avanza. Altrimenti il concetto torna al livello zero.",
  "study.repeat.label": "La tua risposta, di nuovo",
  "study.repeat.submit": "Ripeti",
  "study.repeat.selfGrade": "Valutala tu invece",
  "study.repeat.evalTitle": "Come l'hai ripetuta",
  "error.generic": "Qualcosa è andato storto. Riprova.",
  "error.transport": "Impossibile raggiungere il server. Controlla la connessione e riprova.",
  "error.session": "La sessione è scaduta. Accedi di nuovo.",
  "error.validation": "Alcune informazioni inserite non sono valide.",
  "error.notFound": "Questo elemento non esiste più.",
  "error.tooLarge": "Questo file è troppo grande.",
  "error.unsupported": "Questo tipo di file non è supportato. Usa file PDF, Word, PowerPoint, di testo o Markdown.",
  "error.aiNotConfigured": "L'IA non è ancora configurata sul server.",
  "error.aiUnavailable": "L'IA è temporaneamente non disponibile. Riprova più tardi.",
  "error.aiInvalid": "L'IA ha dato una risposta inutilizzabile. Riprova.",
  "error.state": "Questa azione non è possibile nello stato attuale.",
  "error.server": "Qualcosa è andato storto sul server. Riprova.",
  "error.rateLimited": "Troppi tentativi. Attendi un momento e riprova.",
  "error.managedCourse": "Questo corso viene dal Marketplace: l'autore lo tiene aggiornato, quindi il suo contenuto non si può modificare qui.",
  "studyState.NOT_STUDIED": "Non studiato",
  "studyState.STUDIED": "Studiato",
  "studyState.ACTIVE": "Attivo",
  "studyState.PAUSED": "In pausa",
  "studyState.COMPLETED": "Completato",
  "memoryState.NEW": "Nuova",
  "memoryState.LEARNING": "In apprendimento",
  "memoryState.REVIEW": "In ripasso",
  "memoryState.RELEARNING": "Da riapprendere",
  "memoryState.MASTERED": "Padroneggiata",
  "outcome.AGAIN": "Ancora",
  "outcome.HARD": "Difficile",
  "outcome.GOOD": "Bene",
  "outcome.EASY": "Facile",
  "outcomeHelp.AGAIN": "Non lo sapevo",
  "outcomeHelp.HARD": "Lo sapevo, con fatica",
  "outcomeHelp.GOOD": "Lo sapevo",
  "outcomeHelp.EASY": "Lo sapevo facilmente",
  "classification.CORRECT": "Corretta",
  "classification.PARTIALLY_CORRECT": "Parzialmente corretta",
  "classification.MISCONCEPTION": "Concetto sbagliato",
  "classification.WRONG": "Non corretta",
  "classification.UNCERTAIN": "Incerta",
  "role.CORE_TRAINABLE": "Centrale",
  "role.SUPPORTING_TRAINABLE": "Di supporto",
  "role.COMMON_TRAP": "Trappola comune",
  "role.INFORMATIONAL": "Informativa",
  "role.REFERENCE": "Riferimento",
  "role.OPTIONAL_EXTENSION": "Facoltativa",
  "priority.1": "Essenziale",
  "priority.2": "Importante",
  "priority.3": "Extra",
  "label.page": "Pagina {n}",
  "label.pages": "Pagine {a}–{b}",
  "label.pageShort": "pag. {n}",
  "label.pagesShort": "pagg. {a}–{b}",
  "category.law": "Diritto",
  "category.economics_business": "Economia e impresa",
  "category.accounting_finance": "Contabilità e finanza",
  "category.medicine_health": "Medicina e salute",
  "category.sciences": "Scienze",
  "category.mathematics": "Matematica",
  "category.engineering": "Ingegneria",
  "category.computer_science": "Informatica",
  "category.languages": "Lingue",
  "category.humanities": "Storia e discipline umanistiche",
  "category.arts": "Arte e musica",
  "category.professional_exams": "Esami professionali",
  "category.other": "Altro",
  "level.all": "Tutti i livelli",
  "level.beginner": "Principiante",
  "level.intermediate": "Intermedio",
  "level.advanced": "Avanzato",
  "size.small": "Breve (meno di 50 domande)",
  "size.medium": "Medio (50–299 domande)",
  "size.large": "Grande (300+ domande)",
  "sort.popular": "Più scelti",
  "sort.newest": "Più recenti",
  "sort.largest": "Più domande",
  "lang.it": "Italiano",
  "lang.en": "Inglese",
  "price.free": "Gratis",
  "common.loading": "Caricamento…",
  "common.tryAgain": "Riprova",
  "common.dismiss": "Chiudi",
  "common.delete": "Elimina",
  "common.edit": "Modifica",
  "common.rename": "Rinomina",
  "common.title": "Titolo",
  "common.description": "Descrizione",
  "common.continue": "Continua",
  "common.search": "Cerca",
  "common.add": "Aggiungi",
  "common.remove": "Rimuovi",
  "common.yes": "Sì",
  "common.no": "No",
  "common.collapse": "Comprimi {label}",
  "common.expand": "Espandi {label}",
  "drag.item": "Elemento",
  "drag.reorder": "Riordina {label}",
  "drag.pickedUp": "Preso {label}, posizione {pos} di {total}.",
  "drag.over": "{label} è ora in posizione {pos} di {total}.",
  "drag.dropped": "{label} rilasciato in posizione {pos} di {total}.",
  "drag.droppedPlain": "{label} rilasciato.",
  "drag.cancelled": "Spostamento di {label} annullato.",
  "drawing.loadFailed": "Impossibile caricare il disegno.",
  "course.authorOrder": "L'ordine di questo corso lo decide l'autore.",
  "priority.yours": "La tua priorità",
  "priority.label": "Priorità",
  "priority.author": "Autore: {name}",
  "priority.useAuthor": "Usa quella dell'autore",
  "editTitle.rename": "Rinomina {label}",
  "label.course": "corso",
  "label.chapter": "capitolo",
  "label.topic": "argomento",
  "label.concept": "concetto",
  "library.heading": "I miei corsi",
  "library.count.one": "{n} corso",
  "library.count.other": "{n} corsi",
  "library.shownOf": "{shown} di {total} mostrati",
  "library.search": "Cerca corsi",
  "library.show": "Mostra",
  "library.sortBy": "Ordina per",
  "library.new": "+ Nuovo corso",
  "library.marketplace": "🛒 Marketplace",
  "library.empty": "Ancora nessun corso. Creane uno, poi aggiungi il tuo materiale di studio o le tue domande e risposte.",
  "library.createFirst": "Crea il tuo primo corso",
  "library.noMatch": "Nessun corso corrisponde a questa ricerca o filtro.",
  "libStatus.all": "Tutti i corsi",
  "libStatus.in_progress": "In corso",
  "libStatus.not_started": "Non iniziati",
  "libStatus.due": "Ripassi in scadenza",
  "libStatus.completed": "Niente di nuovo da imparare",
  "libStatus.paused": "In pausa",
  "libStatus.archived": "Archiviati",
  "libSort.recent_study": "Studiati di recente",
  "libSort.recent_created": "Creati di recente",
  "libSort.alphabetical": "Alfabetico",
  "libSort.most_due": "Più ripassi in scadenza",
  "card.marketplacePill": "🛒 Dal marketplace · di {author}",
  "card.marketplaceHint": "L'autore tiene aggiornato il contenuto; lo studio è tuo.",
  "card.continue": "Continua",
  "card.next": "Prossimo",
  "card.archived": "Archiviato",
  "card.paused": "In pausa",
  "card.conceptsStudied": "concetti studiati",
  "card.itemsIntroduced": "elementi di studio introdotti",
  "card.moreFor": "Altro per {title}",
  "menu.details": "Dettagli del corso",
  "menu.material": "Materiale di studio",
  "menu.progress": "Progressi",
  "menu.publish": "🛒 Pubblica sul marketplace",
  "menu.pause": "Metti in pausa",
  "menu.resume": "Riprendi",
  "menu.archive": "Archivia",
  "menu.restore": "Ripristina",
  "menu.delete": "Elimina…",
  "menu.confirmOwn": "Eliminare \"{title}\"? Capitoli, domande, materiale e le tue risposte vengono eliminati per sempre. Archivialo invece per conservare tutto.",
  "menu.confirmMarketplace": "Eliminare \"{title}\"? Potrai aggiungerlo di nuovo dal Marketplace gratuitamente.",
  "newCourse.aria": "Nuovo corso",
  "newCourse.language": "Lingua del materiale",
  "newCourse.create": "Crea corso",
  "learn.resume.label": "Riprendi l'esercizio",
  "learn.resume.hint": "Continua il giro lasciato a metà",
  "learn.study.label": "Impara il prossimo",
  "learn.study.hint": "Studia {title}",
  "learn.study.hintNone": "Impara nuovo materiale",
  "learn.activate.label": "Inizia a imparare",
  "learn.activate.hint": "Prepara le domande di {title} e inizia a studiarlo",
  "learn.activate.hintNone": "Inizia a studiare il prossimo concetto",
  "learn.setup.label": "Aggiungi materiale",
  "learn.setup.hint": "Aggiungi materiale di studio o le tue domande per iniziare",
  "learn.none.label": "Tutto imparato ✓",
  "learn.none.hint": "Tutto in questo corso è stato imparato",
  "review.none": "✓ Niente da ripassare ora",
  "review.noneTitle": "Niente in questo corso ha bisogno di ripasso adesso",
  "review.aria.one": "Ripassa {n} elemento",
  "review.aria.other": "Ripassa {n} elementi",
  "review.button": "Ripassa",
  "course.practiceHard": "Esercitati sulle domande difficili",
  "course.chapters": "Capitoli",
  "course.chaptersEmpty": "Aggiungi un capitolo, poi aggiungici materiale di studio.",
  "course.chapterMeta": "{active} concetti attivi su {total} · padronanza {mastery}",
  "course.newChapter": "Titolo del nuovo capitolo",
  "course.addChapter": "Aggiungi capitolo",
  "course.curriculum": "Programma",
  "course.fallback": "Corso",
  "course.allMaterial": "Tutto il materiale di studio",
  "course.manageQuestions": "Gestisci le domande",
  "course.weakSpots": "Cosa continui a sbagliare",
  "chapter.gone": "Questo capitolo non esiste più.",
  "chapter.topics": "Argomenti",
  "chapter.starting": "Avvio dell'analisi…",
  "chapter.analyze": "Analizza il nuovo materiale",
  "chapter.analyzeHint": "L'IA propone argomenti e concetti dal materiale non ancora analizzato. Rivedi la proposta prima che cambi qualcosa.",
  "chapter.noMaterial": "In questo capitolo non c'è nuovo materiale da analizzare. Carica prima del materiale.",
  "chapter.empty": "Ancora nessun argomento. Carica il materiale qui sotto, poi analizzalo.",
  "chapter.topicMeta": "{active} concetti attivi su {total}",
  "topic.gone": "Questo argomento non esiste più.",
  "topic.concepts": "Concetti",
  "topic.empty": "Nessun concetto in questo argomento.",
  "topic.needsReview": "Fonte da rivedere",
  "topic.conceptMeta": "{state} · padronanza {mastery}",
  "unit.item.one": "{n} elemento",
  "unit.item.other": "{n} elementi",
  "unit.answer.one": "{n} risposta",
  "unit.answer.other": "{n} risposte",
  "consolidate.continue": "Continua il consolidamento",
  "consolidate.unfinished": "Il tuo gruppo di {items} è incompleto: restano {left}. Le risposte già date sono conservate.",
  "consolidate.resume": "Riprendi",
  "consolidate.doneTitle": "Consolidato",
  "consolidate.doneBody": "Ogni elemento di questo concetto ha fatto i suoi giri di consolidamento. Torneranno nei tuoi ripassi alla scadenza.",
  "consolidate.title": "Hai studiato questo concetto?",
  "consolidate.body": "Leggi prima cosa studiare qui sopra. Quando sei pronto, ogni domanda viene posta finché non hai risposto bene {n} volte (non necessariamente di fila), con un riscontro dopo ogni risposta.",
  "consolidate.batch": "Questo gruppo: {items} · {answers}",
  "consolidate.more.one": "{n} elemento in più aspetta un gruppo successivo",
  "consolidate.more.other": "{n} elementi in più aspettano un gruppo successivo",
  "consolidate.button": "Ho studiato questo concetto",
  "breadcrumb.aria": "Percorso",
  "dash.title": "Dashboard",
  "dash.loading": "Caricamento della dashboard…",
  "dash.aside": "Il tuo studio",
  "dash.today": "Oggi",
  "dash.xpTodayPlus": "+{n} XP oggi",
  "dash.goal": "Obiettivo {done}/{target}",
  "dash.tzNote": "I tuoi giorni di studio (serie, obiettivo, XP di oggi) seguono {zone}. Questo dispositivo è in {device}.",
  "dash.tzUse": "Usa {zone}",
  "next.title": "Il tuo prossimo passo",
  "next.resumeTitle": "Continua il consolidamento · Risposta buona {round} di {total}",
  "next.answersLeft": "{n} risposte rimaste",
  "next.resume": "Riprendi",
  "next.minutes": "circa {n} min",
  "next.startReview": "Inizia il ripasso",
  "next.learnTitle": "Continua a imparare: {concept}",
  "next.nextConcept": "prossimo concetto",
  "next.learn": "Impara",
  "next.setupTitle": "Prepara {concept}",
  "next.theNextConcept": "il prossimo concetto",
  "next.setupDetail": "{course} · attivalo per preparare le sue domande",
  "next.setup": "Prepara",
  "next.addMaterialTitle": "Aggiungi materiale a {course}",
  "next.yourCourse": "il tuo corso",
  "next.addMaterialDetail": "Carica materiale di studio o le tue domande e risposte per costruirne i concetti.",
  "next.firstCourse": "Inizia il tuo primo corso",
  "next.firstCourseDetail": "Crea un corso, poi aggiungi materiale o le tue domande.",
  "next.caughtUp": "Sei in pari",
  "next.caughtUpDetail": "Niente in scadenza e nessun nuovo materiale in attesa.",
  "streak.title": "Serie giornaliera",
  "streak.unit.one": "giorno",
  "streak.unit.other": "giorni",
  "streak.done": "Oggi è completo. Torna domani per continuare.",
  "streak.keep": "Rispondi a una domanda oggi per mantenere la serie.",
  "streak.start": "Rispondi a una domanda oggi per iniziare una serie.",
  "streak.last7": "Gli ultimi 7 giorni",
  "streak.studied": "studiato",
  "streak.noStudy": "nessuno studio",
  "xp.title": "Esperienza",
  "xp.how": "Come funzionano gli XP",
  "xp.howBody": "Ogni risposta corretta allo stesso elemento vale di più: 10 XP la prima volta, poi 20, 30… fino a 150. Un suggerimento dimezza gli XP di quella risposta. Le risposte sbagliate non danno nulla ma non azzerano i progressi. Gli XP premiano l'esercizio; non cambiano mai il piano di ripasso.",
  "goal.title": "Obiettivo giornaliero",
  "goal.sr": "Obiettivo giornaliero: {done} risposte completate su {target} oggi, {percent} per cento.",
  "goal.answersToday": "{done} / {target} risposte oggi",
  "goal.perDay": "Risposte al giorno",
  "goal.edit": "Modifica obiettivo",
  "goal.invalid": "Scegli un numero intero da 1 a 500.",
  "planner.title": "Pianificatore",
  "planner.now": "Ora",
  "planner.1h": "Tra 1 ora",
  "planner.4h": "Tra 4 ore",
  "planner.1d": "Tra 1 giorno",
  "planner.3d": "Tra 3 giorni",
  "planner.7d": "Tra 7 giorni",
  "planner.dueNow": "{n} in scadenza ora: circa {min} min",
  "planner.caption": "Ripassi in scadenza entro ogni momento, compresi quelli in ritardo",
  "planner.dueBy": "Scadenza entro",
  "planner.items": "Elementi",
  "planner.hint": "Basato sul tuo piano di ripasso attuale; cambia mentre studi. Ogni riga include tutto ciò che scade prima.",
  "activity.title": "Attività",
  "activity.seeMore": "Vedi altro",
  "activity.future": "{day}: nel futuro",
  "activity.day": "{day}: {answers}",
  "activity.dayXp": "{day}: {answers}, {xp} XP",
  "activity.aria": "Calendario dell'attività: {days}, {answers}",
  "activity.summary": "{days} · {answers}",
  "unit.activeDay.one": "{n} giorno attivo",
  "unit.activeDay.other": "{n} giorni attivi",
  "activity.less": "Meno",
  "activity.more": "Più",
  "activity.legendFuture": "Futuro",
  "pb.curriculumHint": "Quanto del materiale hai studiato e attivato.",
  "pb.conceptsActive": "Concetti attivi",
  "pb.activeOf": "{active} su {total}",
  "pb.memory": "Memoria",
  "pb.memoryHint": "Quanto ricordi ciò che alleni. La padronanza è una stima basata sui tuoi ripassi.",
  "pb.mastery": "Padronanza (stima)",
  "pb.itemsTrained": "Elementi in allenamento",
  "pb.markedHard": "Segnati difficili",
  "pb.dueNow": "In scadenza ora",
  "pb.laterToday": "Più tardi oggi",
  "pb.tomorrow": "Domani",
  "pb.next7": "Prossimi 7 giorni",
  "pb.newToLearn": "Nuovi da imparare",
  "pb.overdue.one": "{n} domanda è in ritardo: parti da quelle.",
  "pb.overdue.other": "{n} domande sono in ritardo: parti da quelle.",
  "pb.caption": "Domande in scadenza in questo corso e circa quanto tempo richiedono",
  "pb.when": "Quando",
  "pb.questions": "Domande",
  "pb.time": "Tempo",
  "pb.minutes": "~{n} min",
  "study.intent.LEARN": "Impara",
  "study.intent.SCHEDULED_REVIEW": "Ripasso",
  "study.intent.PRACTICE": "Esercizio",
  "study.intent.EXAM": "Esame",
  "study.intent.CONSOLIDATION": "Consolidamento",
  "study.round": "Risposta buona {n} di {total}",
  "study.progressAria": "Avanzamento in questa sessione",
  "study.progress": "{n} di {total}",
  "study.xpSessionAria": "{n} XP in questa sessione",
  "study.ownReview": "Ripasso libero: il piano non cambia, niente XP",
  "study.leaveResume": "Esci (riprendi dopo)",
  "study.end": "Termina sessione",
  "study.preparing": "Preparazione della sessione…",
  "study.empty.title": "Niente da studiare adesso",
  "study.empty.body": "Niente è adatto a questa sessione. Attiva un concetto per aggiungere nuovo materiale, o torna quando i ripassi sono in scadenza.",
  "study.empty.back": "Torna al corso",
  "study.newMaterial": "Nuovo materiale",
  "study.keyPoints": "Punti chiave",
  "study.sources": "Fonti",
  "study.ready": "Sono pronto: interrogami",
  "study.answering": "Rispondere",
  "study.drawHint": "Disegna la tua risposta qui sotto. L'IA la confronta con il disegno di riferimento.",
  "study.note": "Nota (facoltativa)",
  "study.yourAnswer": "La tua risposta",
  "study.notePlaceholder": "Qualcosa da aggiungere al disegno…",
  "study.answerPlaceholder": "Rispondi con parole tue…",
  "study.stopListening": "Smetti di ascoltare",
  "study.speak": "Dì la tua risposta",
  "study.evaluating": "Valutazione in corso…",
  "study.submit": "Invia",
  "study.skip": "Salta questa domanda",
  "study.dictationOn": "La dettatura è trascritta dal tuo browser, che può inviare l'audio al suo servizio vocale. Viene conservato solo il testo; modificalo prima di inviare.",
  "study.dictationOff": "Le risposte vocali richiedono Chrome, Edge o Safari. Qui puoi scrivere la risposta.",
  "study.drawingCompare": "Il tuo disegno e quello di riferimento",
  "study.yourDrawing": "Il tuo disegno",
  "study.reference": "Riferimento",
  "study.gradedByYou": "Valutato da te",
  "study.needsGrade": "Serve il tuo voto",
  "study.firstEval": "Prima valutazione",
  "study.secondOpinion": "Secondo parere",
  "study.afterObjection": "Dopo la tua obiezione: «{text}»",
  "study.referenceSummary": "Risposta di riferimento e fonti",
  "study.studyConcept": "📖 Studia questo concetto",
  "study.gradeHow": "Quanto lo sapevi bene?",
  "study.gradeYourself": "Oppure valutala tu",
  "study.yourGrade": "Il tuo voto",
  "study.retryEval": "Riprova la valutazione",
  "study.skipNow": "Salta per ora",
  "study.disagree": "Non sei d'accordo con il voto?",
  "study.notMemorized": "Non ancora memorizzato: lo rivedrai in questa sessione.",
  "study.levelNext": "Livello {from} → {to}. Prossimo ripasso: {when}",
  "study.practiceNote": "L'esercizio non cambia il tuo piano di ripasso.",
  "study.complete": "Sessione completata",
  "study.xpSessionPlus": "+{n} XP in questa sessione",
  "study.answeredIn": "{answers} in circa {min} min.",
  "study.wentWell": "{n} sono andate bene.",
  "study.steady": "Lavoro costante: sta iniziando a fissarsi.",
  "study.comeBack": "Quelle andate male tornano presto, ed è così che si fissano.",
  "study.stillDue": "Ancora in scadenza adesso: {n} (circa {min} min).",
  "study.nothingDue": "Nient'altro è in scadenza adesso.",
  "study.done": "Fatto",
  "study.noXp": "Questa risposta non dà XP (esercizio, o non ancora in scadenza).",
  "study.correctXp": "Risposta corretta: +{n} XP",
  "study.halfXp": "(suggerimento usato: metà XP)",
  "study.hintLabel": "Suggerimento",
  "study.noHint": "Nessun suggerimento per questa domanda.",
  "study.showHint": "Mostra suggerimento",
  "study.hintHalves": "Usare un suggerimento dimezza gli XP di questa risposta.",
  "study.revealHint": "Rivela il suggerimento",
  "study.plusZero": "+0 XP",
  "study.onlyCorrectSelf": "Solo le risposte corrette danno XP: contano anche i tuoi voti Difficile, Bene o Facile.",
  "study.onlyCorrect": "Solo le risposte del tutto corrette danno XP. I tuoi progressi verso il prossimo premio sono conservati.",
  "study.awardCorrect": "Corretta",
  "study.awardHint": "Suggerimento usato",
  "study.ordinal": "risposta corretta n. {n} per questo elemento",
  "study.ordinalHalf": "risposta corretta n. {n} per questo elemento, metà di {base}",
  "study.batchDone": "Gruppo consolidato",
  "study.correctAnswers": "Risposte corrette",
  "study.xpThisSession": "XP di questa sessione",
  "study.whatNext": "Cosa succede dopo",
  "study.whatNextBody": "Gli elementi con l'ultimo giro corretto tornano in ripasso tra circa 4 ore; gli altri aspettano il gruppo successivo.",
  "study.waiting.one": "{n} elemento in più è in attesa",
  "study.waiting.other": "{n} elementi in più sono in attesa",
  "study.batchNotAll": "Questo gruppo è finito, non l'intero concetto: {waiting}.",
  "study.allRounds": "Ogni voce di questo concetto che era in attesa ha avuto tre risposte buone.",
  "study.nextBatch": "Gruppo successivo",
  "study.conceptCosts": "Guardare ora il concetto conta come usare un suggerimento: questa risposta vale metà XP.",
  "study.openConcept": "Apri il concetto",
  "study.dontRemember": "📖 Non ricordi? Studia questo concetto",
  "study.refDrawing": "Il disegno di riferimento",
  "dispute.title": "Chiedi all'IA di rivedere",
  "dispute.testAi": "L'IA di prova non può leggere la tua obiezione: un secondo parere ripeterebbe lo stesso voto. Valutala tu qui sotto.",
  "dispute.why": "Perché non sei d'accordo?",
  "dispute.placeholder": "Di cosa ha sbagliato la valutazione…",
  "dispute.hint": "L'IA vede la tua obiezione e valuta di nuovo. Entrambi i pareri restano visibili; il tuo voto cambia solo se lo scegli qui sotto.",
  "dispute.asking": "Richiesta in corso…",
  "dispute.ask": "Chiedi un secondo parere",
  "eval.correct": "Corretto",
  "eval.complete": "Completo",
  "eval.understanding": "Comprensione",
  "eval.precise": "Preciso",
  "eval.Strong": "Forte",
  "eval.Partial": "Parziale",
  "eval.Weak": "Debole",
  "eval.scoreBreakdown": "Dettaglio dei punteggi",
  "eval.right": "Giusto",
  "eval.missing": "Mancante",
  "eval.misconception": "Concetto sbagliato",
  "eval.materialSays": "Il materiale dice",
  "eval.covered": "Cosa copriva la tua risposta",
  "eval.failed": "Non è stato possibile valutare la risposta.",
  "eval.aiEvaluation": "Valutazione IA: {verdict}",
  "eval.insufficient": "Il materiale del corso non copre abbastanza questo punto per valutarlo.",
  "eval.testAiTitle": "IA di prova.",
  "eval.testAiBody": "Questo voto viene da un sostituto che si limita a confrontare le parole con il riferimento: non capisce parafrasi né obiezioni. Controlla il riferimento e valuta tu, oppure collega una vera IA.",
  "conceptPanel.title": "Studia questo concetto",
  "conceptPanel.next": "Ho studiato — prossima domanda",
  "conceptPanel.closeAria": "Chiudi il concetto",
  "conceptPanel.loading": "Caricamento del concetto…",
  "conceptPanel.openFull": "Apri la pagina completa del concetto in una nuova scheda",
  "dictation.blocked": "Il microfono è bloccato. Consentilo nelle impostazioni del sito del browser per dettare.",
  "dictation.network": "Il riconoscimento vocale richiede una connessione a internet.",
  "dictation.noMic": "Nessun microfono trovato.",
  "dictation.stopped": "Il riconoscimento vocale si è fermato inaspettatamente. Puoi continuare a scrivere.",
  "concept.activate": "Attiva",
  "concept.activateHelp": "Prepara le domande di questo concetto dal tuo materiale così puoi studiarlo.",
  "concept.markStudied": "Segna come studiato",
  "concept.markStudiedHelp": "L'hai studiato altrove: viene annotato, senza ancora preparare domande.",
  "concept.activateAgainHelp": "Lo studia di nuovo: le sue domande tornano nelle tue sessioni.",
  "concept.pause": "Metti in pausa",
  "concept.pauseHelp": "Ferma le sue domande per un po'. Non si perde nulla.",
  "concept.deactivate": "Disattiva",
  "concept.deactivateHelp": "Lo toglie da studio e ripassi. Risposte e cronologia sono conservate.",
  "concept.resume": "Riprendi",
  "concept.resumeHelp": "Riporta le sue domande in studio e ripassi.",
  "concept.sourceDeleted": "Il materiale da cui veniva questo concetto è stato eliminato. Conservalo, modificalo o eliminalo.",
  "concept.manage": "Gestisci questo concetto",
  "concept.loadingItems": "Caricamento degli elementi di studio…",
  "concept.preparing": "Preparazione degli elementi di studio…",
  "concept.itemsFailed": "Non è stato possibile preparare gli elementi di studio.",
  "concept.noSource": "Questo concetto non ha materiale di partenza da cui costruire elementi di studio.",
  "concept.whatToStudy": "Cosa studiare",
  "concept.reviewOwnHelp": "Fatti interrogare su questo concetto quando vuoi. Non cambia il tuo piano di ripasso e non dà XP.",
  "concept.reviewOwn": "🔁 Ripassa da solo",
  "concept.readThen": "Leggili, poi premi \"Ho studiato questo concetto\" qui sotto per esercitarti.",
  "concept.testMe": "🔁 Interrogami su questo",
  "concept.hideDetails": "Nascondi i dettagli",
  "concept.details": "Dettagli",
  "concept.level": "Livello {n}",
  "concept.markedHard": "Segnato difficile",
  "concept.notTraining": "Non in allenamento",
  "concept.state": "Stato",
  "concept.levelLabel": "Livello",
  "concept.nextReview": "Prossimo ripasso",
  "concept.reviews": "Ripassi",
  "concept.lapses": "Dimenticanze",
  "concept.inTraining": "In allenamento",
  "concept.questions": "Domande",
  "concept.sourcesTitle": "Fonti",
  "concept.loadingSources": "Caricamento delle fonti…",
  "concept.noSources": "Nessun passaggio di fonte.",
  "concept.misconceptions": "Concetti sbagliati ricorrenti",
  "drawing.answerBy": "Rispondi disegnando",
  "drawing.studentsDraw": "Gli studenti rispondono a questa domanda disegnando. L'IA confronta il loro disegno con questo.",
  "drawing.youDraw": "Rispondi a questa domanda disegnando. L'IA confronta il tuo disegno con questo.",
  "drawing.referenceAlt": "Disegno di riferimento",
  "drawing.explain": "Per le domande con risposta a disegno (una molecola, uno schema, un grafico): aggiungi il disegno corretto e gli studenti disegneranno la risposta invece di scriverla.",
  "drawing.save": "Salva questo disegno",
  "drawing.replace": "Sostituisci con un'immagine…",
  "drawing.upload": "Carica il disegno…",
  "drawing.drawNew": "Disegnane uno nuovo",
  "drawing.drawHere": "Disegnalo qui",
  "drawing.words": "Rispondi invece a parole",
  "drawing.tools": "Strumenti di disegno",
  "drawing.pen": "✏️ Penna",
  "drawing.eraser": "🧽 Gomma",
  "drawing.thick": "Linea spessa",
  "drawing.thin": "Linea sottile",
  "drawing.undo": "↶ Annulla",
  "drawing.clear": "Cancella",
  "drawing.area": "Area di disegno: disegna qui la tua risposta",
  "drawing.photoUpload": "L'hai disegnato su carta? Carica una foto",
  "drawing.photoError": "Quel file non è un'immagine che questo browser può leggere. Prova con una foto JPEG o PNG.",
  "drawing.photoAlt": "La tua foto del disegno",
  "drawing.drawInstead": "Disegna invece",
  "q.title": "Domande",
  "q.introOwn": "Seleziona le domande per eliminarle, sospenderle, riprenderle o spostarle; trascina ⠿ per riordinarle; modificane una per correggere titolo, formulazione o risposta attesa.",
  "q.introManaged": "Questo corso viene dal Marketplace: l'autore tiene aggiornate le domande. Seleziona le domande per sospenderle o riprenderle, oppure dai loro una priorità tua (la vedi solo tu).",
  "q.search": "Cerca domande",
  "q.searchPlaceholder": "Cerca domande e risposte",
  "q.allPriorities": "Tutte le priorità",
  "q.priorityOnly": "Solo {label} ({n})",
  "q.deselectAll": "Deseleziona tutto",
  "q.selectAll": "Seleziona tutto ({n})",
  "q.selectAllShown": "Seleziona tutto ciò che è mostrato ({n})",
  "q.collapseAll": "Comprimi tutto",
  "q.expandAll": "Espandi tutto",
  "q.selectedAria": "Domande selezionate",
  "q.selectedCount": "{n} selezionate",
  "q.moveTo": "Sposta in…",
  "q.setPriority": "Imposta la priorità",
  "q.setPriorityPlaceholder": "Imposta la priorità…",
  "q.reviewSelectedHelp": "Fatti interrogare ora sulle domande selezionate. Non cambia il tuo piano di ripasso e non dà XP.",
  "q.clearSelection": "Annulla la selezione",
  "q.verb.delete": "Eliminate",
  "q.verb.pause": "Sospese",
  "q.verb.resume": "Riprese",
  "q.verb.move": "Spostate",
  "q.verb.set_priority": "Aggiornate",
  "unit.question.one": "{n} domanda",
  "unit.question.other": "{n} domande",
  "unit.chapter.one": "{n} capitolo",
  "unit.chapter.other": "{n} capitoli",
  "unit.topic.one": "{n} argomento",
  "unit.topic.other": "{n} argomenti",
  "unit.concept.one": "{n} concetto",
  "unit.concept.other": "{n} concetti",
  "unit.group.one": "{n} gruppo svuotato",
  "unit.group.other": "{n} gruppi svuotati",
  "q.newConcepts.one": "{n} nuovo concetto",
  "q.newConcepts.other": "{n} nuovi concetti",
  "q.removedConcepts.one": "{n} concetto vuoto rimosso",
  "q.removedConcepts.other": "{n} concetti vuoti rimossi",
  "q.noticeBulk": "{verb} {questions}{extra}.",
  "q.noticeDeleted": "Eliminate {questions}.",
  "q.noticeDeletedGroups": "Eliminate {questions} e {groups}.",
  "q.confirmDelete": "Eliminare {questions}? Anche le loro risposte e la cronologia dei ripassi vengono eliminate.{also}",
  "q.confirmAlso": " Anche {groups} rimasti senza domande vengono eliminati.",
  "q.emptySearch": "Nessuna domanda corrisponde a questa ricerca.",
  "q.empty": "Ancora nessuna domanda. Attiva un concetto o importa le tue domande e risposte.",
  "q.clearToReorder": "Svuota la ricerca per riordinare queste domande.",
  "q.select": "Seleziona: {text}",
  "q.otherWordings.one": "+{n} altra formulazione",
  "q.otherWordings.other": "+{n} altre formulazioni",
  "q.editAria": "Modifica domanda",
  "q.titleLabel": "Titolo (mostrato negli elenchi)",
  "q.wordings": "Formulazioni della domanda",
  "q.wording": "Formulazione {n}",
  "q.addWording": "+ Aggiungi un'altra formulazione",
  "q.expected": "Risposta attesa",
  "q.prio1": "Essenziale: il nucleo, da sapere",
  "q.prio2": "Importante: da sapere",
  "q.prio3": "Extra: approfondimento, dettaglio",
  "q.keyPoints": "Punti chiave (uno per riga, fino a 10)",
  "q.moveAria": "Sposta domande",
  "q.moveHeading": "Sposta {questions} in",
  "q.choose": "Scegli un argomento o un concetto…",
  "q.topicOption": "Argomento: {title} (ogni domanda mantiene il suo concetto)",
  "q.conceptOption": "   ↳ nel concetto: {title}",
  "q.removeEmpty": "Rimuovi i concetti rimasti senza domande",
  "q.moveHint": "Le domande conservano i progressi di ripasso. In un concetto non attivo non vengono ripassate finché non lo diventa.",
  "q.move": "Sposta",
  "q.groupSelect": "Seleziona ogni domanda in {label}",
  "mat.chapterTitle": "Materiale del capitolo",
  "mat.collapseLabel": "materiale di studio",
  "mat.files.one": "{n} file",
  "mat.files.other": "{n} file",
  "mat.uploading": "Caricamento…",
  "mat.upload": "Carica materiale",
  "mat.uploadQa": "Carica domande e risposte",
  "mat.paste": "Incolla testo",
  "mat.howTo": "Come preparare domande e risposte",
  "mat.howToBody": "Carica un file PDF, Word, di testo o Markdown in cui ogni domanda inizia con “Domanda:” e la risposta attesa con “Risposta:” (oppure “Question:” / “Answer:”), a inizio riga. I titoli raggruppano le domande in argomenti.",
  "mat.howToBody2": "Ogni domanda diventa un concetto segnato come non studiato, con la tua risposta come risposta attesa. Attivalo per iniziare a ripassare. Per l'importazione non si usa l'IA.",
  "mat.loading": "Caricamento del materiale…",
  "mat.none": "Ancora nessun materiale. Carica file PDF, Word, PowerPoint, di testo o Markdown.",
  "mat.file": "File",
  "mat.status": "Stato",
  "mat.passages": "Passaggi",
  "mat.added": "Aggiunto",
  "mat.actions": "Azioni",
  "mat.qa": "Q&A",
  "mat.processing": "Elaborazione…",
  "mat.ready": "Pronto",
  "mat.failed": "Non riuscito",
  "mat.download": "Scarica",
  "mat.confirmDelete": "Eliminare {name}? I concetti costruiti da esso saranno segnalati per la revisione.",
  "mat.pasteAria": "Incolla testo",
  "mat.pastePlaceholder": "es. Appunti della lezione 3",
  "mat.thisTextIs": "Questo testo è",
  "mat.asMaterial": "Materiale di studio",
  "mat.asQa": "Domande e risposte (Domanda: / Risposta:)",
  "mat.text": "Testo",
  "mat.textPlaceholderQa": "# Argomento\nDomanda: …?\nRisposta: …",
  "mat.textPlaceholder": "# Titolo\nI tuoi appunti…",
  "mat.adding": "Aggiunta in corso…",
  "mat.addText": "Aggiungi testo",
  "mat.pastedName": "Testo incollato {when}",
  "prop.title": "Programma proposto",
  "prop.reading": "L'IA sta leggendo il tuo materiale…",
  "prop.applied": "Questa proposta è già stata applicata.",
  "prop.failed": "L'IA non è riuscita a proporre un programma.",
  "prop.blank": "Ogni capitolo, argomento e concetto ha bisogno di un titolo.",
  "prop.longMaterial": "Il materiale era lungo: questo copre i primi {used} passaggi su {total}.",
  "prop.dropped": "{n} concetti proposti sono stati esclusi perché non collegabili al tuo materiale.",
  "prop.hint": "Modifica tutto qui sotto: rinomina, riordina, sposta concetti tra argomenti, unisci, elimina o aggiungi. Niente viene attivato: scegli tu cosa studiare dopo.",
  "prop.chapterTitle": "Titolo del capitolo",
  "prop.deleteChapter": "Elimina capitolo",
  "prop.accept": "Accetta il programma",
  "prop.reject": "Rifiuta la proposta",
  "prop.topicAria": "Argomento {title}",
  "prop.existingTopic": "argomento esistente",
  "prop.topicTitle": "Titolo dell'argomento",
  "prop.moveTopicUp": "Sposta l'argomento in su",
  "prop.moveTopicDown": "Sposta l'argomento in giù",
  "prop.deleteTopic": "Elimina argomento",
  "prop.conceptTitle": "Titolo del concetto",
  "prop.exists": "esiste già",
  "prop.moveConceptUp": "Sposta il concetto in su",
  "prop.moveConceptDown": "Sposta il concetto in giù",
  "prop.moveToTopic": "Sposta nell'argomento",
  "prop.untitled": "Argomento senza titolo",
  "prop.merge": "Unisci con il successivo",
  "prop.addConcept": "+ Aggiungi concetto",
  "mkt.intro": "Corsi creati da altri utenti di LEARNABLE. Aggiungine uno ai tuoi corsi e studialo con il tuo piano: l'autore lo tiene aggiornato. Per condividerne uno tuo, aprilo e compila la sua “Pagina del marketplace”.",
  "mkt.categories": "Categorie",
  "mkt.all": "Tutte",
  "mkt.searchPlaceholder": "Cerca per titolo o descrizione",
  "mkt.level": "Livello",
  "mkt.language": "Lingua",
  "mkt.size": "Dimensione",
  "mkt.sort": "Ordina",
  "mkt.any": "Qualsiasi",
  "mkt.loading": "Caricamento dei corsi…",
  "mkt.noMatch": "Nessun corso corrisponde ancora a questi filtri.",
  "mkt.publishedByMe": "Pubblicati da me",
  "mkt.status.DRAFT": "Bozza",
  "mkt.status.PUBLISHED": "Pubblicato",
  "mkt.status.UNPUBLISHED": "Non pubblicato",
  "mkt.version": "versione {n}",
  "mkt.students.one": "{n} studente",
  "mkt.students.other": "{n} studenti",
  "mkt.editCourse": "Modifica il corso e la sua pagina",
  "mkt.by": "di {author}",
  "mkt.inYourCourses": "Nei tuoi corsi",
  "mkt.loadingCourse": "Caricamento del corso…",
  "mkt.updated": "aggiornato il {date}",
  "mkt.statStudents": "Studenti",
  "mkt.yourCourse": "Il tuo corso",
  "mkt.draftTag": "bozza",
  "mkt.notPublishedTag": "non pubblicato",
  "mkt.open": "Apri nei miei corsi",
  "mkt.addBack": "Aggiungi di nuovo ai miei corsi",
  "mkt.add": "Aggiungi ai miei corsi · {price}",
  "mkt.about": "Informazioni su questo corso",
  "mkt.learn": "Cosa imparerai",
  "mkt.audience": "A chi è rivolto",
  "mkt.hiddenNote": "Domande e risposte diventano visibili quando il corso è nei tuoi corsi. Le studi dentro LEARNABLE: il materiale dell'autore non si può scaricare.",
  "sales.originTitle": "🛒 Dal marketplace",
  "sales.madeBy": "Creato da {author} (versione {version}). L'autore tiene aggiornati capitoli, domande e risposte, quindi non puoi modificarli qui: gli aggiornamenti ti arrivano in automatico.",
  "sales.yourStudy": "Lo studio è tuo: attivare concetti, mettere in pausa, le tue risposte, il tuo piano di ripasso e gli XP, e la priorità che dai a ogni domanda (la vedi solo tu).",
  "sales.seePage": "Vedi la sua pagina sul marketplace",
  "sales.title": "🛒 Pagina del marketplace",
  "sales.pPublished": "Pubblicato · versione {n}",
  "sales.pNot": "Non pubblicato",
  "sales.pDraft": "Bozza",
  "sales.pNone": "Non condiviso",
  "sales.explain": "Condividi questo corso con altri utenti. Qui scrivi la sua pagina, l'unica cosa che le persone vedono prima di aggiungerlo: cosa tratta, a chi è rivolto, cosa impareranno. Vedono anche i titoli dei capitoli e quante domande ci sono; le domande vere e proprie solo dopo averlo, e il tuo materiale caricato mai.",
  "sales.seeAsOthers": "Guardala come la vedono gli altri",
  "sales.edit": "Modifica la pagina del marketplace",
  "sales.write": "Scrivi una pagina del marketplace",
  "sales.subtitle": "Sottotitolo",
  "sales.subtitleHint": "(una riga, es. “Tutte le 300 domande dell'orale, con risposte modello”)",
  "sales.category": "Categoria",
  "sales.description": "Descrizione",
  "sales.descriptionHint": "(cosa tratta, come l'hai realizzato, come usarlo)",
  "sales.outcomes": "Cosa impareranno gli studenti",
  "sales.outcomesHint": "(uno per riga, fino a 8)",
  "sales.tags": "Tag",
  "sales.tagsHint": "(separati da virgola, fino a 8)",
  "sales.saveDraft": "Salva bozza",
  "sales.savePage": "Salva pagina",
  "sales.publish": "Pubblica",
  "sales.publishUpdate": "Pubblica un aggiornamento",
  "sales.publishHintUpdate": "Invia i tuoi capitoli, domande e risposte attuali a tutti quelli che hanno il corso. I loro progressi sono conservati.",
  "sales.publishHint": "Rende il corso visibile nel Marketplace. Per ora è gratuito. Puoi continuare a modificarlo e pubblicare aggiornamenti dopo.",
  "sales.rights": "Le domande e le risposte sono mie da condividere (le ho scritte io, o ho i diritti sul materiale da cui provengono).",
  "sales.publishing": "Pubblicazione…",
  "sales.publishUpdateBtn": "Pubblica aggiornamento",
  "sales.unpublish": "Rimuovi dalla pubblicazione",
  "sales.noteSaved": "Salvato: la pagina del marketplace lo mostra ora.",
  "sales.noteDraft": "Bozza salvata. Nessun altro la vede finché non pubblichi.",
  "sales.notePublishedV": "Versione {n} pubblicata: tutti quelli che hanno il corso ricevono ora le tue domande più recenti.",
  "sales.notePublished": "Pubblicato! Gli altri utenti ora possono trovarlo nel Marketplace.",
  "sales.noteUnpublished": "Rimosso dalla pubblicazione: i nuovi utenti non lo trovano. Chi lo ha già lo conserva.",
  "prog.empty": "Crea un corso e inizia a imparare per vedere i tuoi progressi.",
  "prog.weakConcepts": "Concetti deboli",
  "prog.weakMeta": "dimenticanze: {lapses} · segnati difficili: {hard}",
  "prog.byChapter": "Per capitolo e argomento",
  "prog.colChapter": "Capitolo / argomento",
  "weak.intro": "Errori trovati nelle tue risposte recenti, per concetto. Scompaiono quando le tue ultime risposte all'elemento non li mostrano più. L'esercizio non cambia il piano di ripasso.",
  "weak.loading": "Controllo delle tue risposte recenti…",
  "weak.empty": "Nessun errore ricorrente al momento. Continua a rispondere e compariranno qui.",
  "weak.practiceTop.one": "Esercitati sul concetto principale ({n})",
  "weak.practiceTop.other": "Esercitati sui primi {n} concetti",
  "weak.practiceThis": "Esercitati su questo",
  "weak.seen.one": "visto {n} volta, l'ultima il {date}",
  "weak.seen.other": "visto {n} volte, l'ultima il {date}",
  "home.intro": "I ripassi programmati conservano ciò che hai imparato. I conteggi in scadenza seguono le stesse regole di una sessione di ripasso.",
  "home.noCourses": "Ancora nessun corso.",
  "home.createOnDashboard": "Creane uno nella tua dashboard",
  "home.meta": "{due} in scadenza ora · {introduced} elementi su {trained} introdotti",
  "activity.pageIntro": "Risposte completate per giorno nell'ultimo anno, nel tuo fuso orario. Una risposta conta quando ha un voto finale, giusta o sbagliata che sia.",
  "reset.title": "Reimposta la password",
  "reset.intro": "Inserisci l'email del tuo account. Ti invieremo un link per scegliere una nuova password; funziona una sola volta, per 30 minuti.",
  "reset.send": "Invia il link di reimpostazione",
  "reset.sentMessage": "Se esiste un account con questa email, sta arrivando un link per reimpostare la password. Controlla la posta in arrivo (e lo spam).",
  "reset.back": "Torna all'accesso",
  "reset.chooseTitle": "Scegli una nuova password",
  "reset.incomplete": "Questo link è incompleto. Riapri il link dall'email, oppure chiedine uno nuovo.",
  "reset.done": "La tua password è stata cambiata. Tutti i dispositivi sono stati disconnessi: accedi con la nuova password.",
  "reset.newPassword": "Nuova password",
  "reset.repeat": "Ripeti la nuova password",
  "reset.tooShort": "Usa almeno {n} caratteri.",
  "reset.mismatch": "Le due password non coincidono.",
  "reset.set": "Imposta la nuova password",
  "source.aria": "Passaggio della fonte",
  "source.closeAria": "Chiudi la fonte",
  "source.loading": "Caricamento del passaggio…",
  "source.open": "Apri il passaggio della fonte",
  "course.loadingCurriculum": "Caricamento del programma…",
  "mkt.addPlain": "Aggiungi ai miei corsi",
  "sales.pageName": "Pagina del marketplace",
};
